import axios from 'axios'
/* import Cookies from 'js-cookie' */
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  expire: localStorage.getItem('v16-expire'),
  token: localStorage.getItem('v16-token') /* Cookies.get('token') */
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  expire: state => state.expire,
  check: state => state.user !== null
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, expire, user }) {
    state.token = token
    //Cookies.set('token', token, { expires: remember ? 365 : null })
    localStorage.setItem('v16-token', token)
    localStorage.setItem('v16-expire', expire)

    state.user = user
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    state.expire = null
    //Cookies.remove('token')
    localStorage.removeItem('v16-token')
    localStorage.removeItem('v16-expire')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null
    state.expire = null

    //Cookies.remove('token')
    localStorage.removeItem('v16-token')
    localStorage.removeItem('v16-expire')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser ({ commit }) {
    try {
      const { data } = await axios.post('/api/info')
      commit(types.FETCH_USER_SUCCESS, { user: data.data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js